import React from "react";
import { CONFIG, isProd } from "../const/config";

const Cta = ({
  children,
  type,
  label,
  link,
  classes = "",
  icon = "before",
  newWindow = false,
}) => {
  return (
    <a
      className={`btn btn-${type} type--uppercase ${
        classes.length ? classes : ""
      }`}
      href={link}
      {...(newWindow && {
        target: "blank",
      })}
    >
      {icon === "before" ? (
        <>
          {children} {label}
        </>
      ) : (
        <>
          {label} {children}
        </>
      )}
    </a>
  );
};

export default Cta;
